import {FileData} from "@/pages/buddy/types/FileData.ts";
import {JobDetailsData} from "@/pages/buddy/types/JobDetailsData.ts";

export interface SocialMediaLinks {
    [key: string]: string | null;
}

// Example interface for an LLM log entry (optional, replace any[] below for stronger typing)
// export interface ILLMLogEntry {
//   p_id: string;
//   filled_prompt: string;
//   llm_response: string;
//   sanitized_output: string;
//   // etc.
// }

// Define the CompanyDetailsData interface
export interface CompanyDetailsData {
    p_id: string;
    is_active: boolean;
    name: string;
    description?: string | null;
    created_at: string | null;
    updated_at: string | null;
    website_url?: string | null;
    industry?: string | null;
    number_of_employees?: number | null;
    headquarters_address?: string | null;
    founding_date?: string | null;
    social_media_links: SocialMediaLinks;
    mission_statement?: string | null;
    values: string[];
    departments: string[];
    jobs: JobDetailsData[];
    image_url?: string | null;
    files: FileData[];
    llm_log?: ILLMLogEntry[];
}

// Define the FieldType type
type FieldType = 'text' | 'date' | 'boolean' | 'array' | 'number' | 'object';

// Define the FieldConfig interface
interface FieldConfig {
    label: string;
    editable: boolean;
    type: FieldType;
    display?: boolean; // Whether to display this field
}

// Create the companyFieldConfig object
export const companyFieldConfig: Record<keyof CompanyDetailsData, FieldConfig> = {
    p_id: { label: 'Company ID', editable: false, type: 'text', display: false },
    is_active: { label: 'Is Active', editable: true, type: 'boolean', display: true },
    name: { label: 'Name', editable: true, type: 'text', display: true },
    description: { label: 'Description', editable: true, type: 'text', display: false },
    created_at: { label: 'Created At', editable: false, type: 'date', display: true },
    updated_at: { label: 'Updated At', editable: false, type: 'date', display: true },
    website_url: { label: 'Website URL', editable: true, type: 'text', display: true },
    industry: { label: 'Industry', editable: true, type: 'text', display: true },
    number_of_employees: { label: 'Number of Employees', editable: true, type: 'number', display: true },
    headquarters_address: { label: 'Headquarters Address', editable: true, type: 'text', display: true },
    founding_date: { label: 'Founding Date', editable: true, type: 'date', display: true },
    social_media_links: { label: 'Social Media Links', editable: true, type: 'text', display: false },
    mission_statement: { label: 'Mission Statement', editable: true, type: 'text', display: true },
    values: { label: 'Values', editable: false, type: 'array', display: false },
    departments: { label: 'Departments', editable: false, type: 'array', display: false },
    jobs: { label: 'Jobs', editable: false, type: 'array', display: false },
    files: { label: 'Files', editable: false, type: 'array', display: false },
    image_url: { label: 'Image', editable: false, type: 'text', display: false },

    llm_log: { label: 'LLM Log', editable: false, type: 'array', display: false },
};
